import { useApiFetcherSWR } from "hooks/SwrCustom";

export const API_ENDPOINT = {
    GET_COMMUNITIES: {
        url: "power-bi/community-lists",
        method: "get",
    },

    GET_ENDPOINTS: {
        url: "power-bi/endpoints-list",
        method: "get",
    },

    POST_UPDATE_POWERBI: {
        url: "power-bi/update",
        method: "post",
    },
};

export const useCommunities = () =>
    useApiFetcherSWR(API_ENDPOINT.GET_COMMUNITIES);

export const useEndpoints = () =>
    useApiFetcherSWR(API_ENDPOINT.GET_ENDPOINTS);

export const useUpdatePowerBi = () =>
    useApiFetcherSWR(API_ENDPOINT.POST_UPDATE_POWERBI);